function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { FormGroup, Radio } from 'react-bootstrap';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './YesNo.css';

var YesNo = function (_Component) {
  _inherits(YesNo, _Component);

  function YesNo() {
    var _temp, _this, _ret;

    _classCallCheck(this, YesNo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentDidUpdate = function () {
      var form = _this.context.form;
      var name = _this.props.name;

      // If the set of questions is not named, we don't need to run this logic

      if (name) {
        // We should only set the form's value if we're changing it
        var set = function set(v) {
          return form.get(name) !== v && form.set(name, v);
        };

        // We have all our YesNo answers
        set(_this.allAnswered() && _this.allOK() ? 'ok' : '');
      }
    }, _this.shouldRender = function (question) {
      return !question.only_if || _this.context.form.get(question.only_if.name) === question.only_if.value;
    }, _this.renderQuestion = function (question, i) {
      var form = _this.context.form;
      var name = question.name;

      if (!_this.shouldRender(question)) {
        return React.createElement('div', { key: name });
      }

      var checked = function checked(v) {
        return form.get(name) === v;
      };
      var set = function set(v) {
        return function () {
          return form.set(name, v);
        };
      };

      return React.createElement(
        'div',
        { className: 'YesNo-Row', key: name },
        React.createElement(
          'div',
          { className: 'YesNo-Index' },
          i + 1,
          '.'
        ),
        React.createElement(
          'div',
          { className: 'YesNo-Text' },
          question.label
        ),
        React.createElement(
          FormGroup,
          { className: 'YesNo-Radio' },
          React.createElement(
            Radio,
            { inline: true, checked: checked('yes'), onChange: set('yes') },
            'Yes'
          ),
          React.createElement(
            Radio,
            { inline: true, checked: checked('no'), onChange: set('no') },
            'No'
          )
        )
      );
    }, _this.allAnswered = function () {
      return _this.props.questions.filter(_this.shouldRender).map(function (q) {
        return Boolean(_this.context.form.get(q.name));
      }).reduce(function (acc, val) {
        return val && acc;
      }, true);
    }, _this.allOK = function () {
      var _this$props = _this.props,
          constraint = _this$props.constraint,
          questions = _this$props.questions;

      if (!constraint) {
        return true;
      }

      var form = _this.context.form;

      var matches = questions.map(function (q) {
        return !_this.shouldRender(q) || form.get(q.name) === constraint.value;
      });

      switch (constraint.type) {
        case 'all':
          return matches.reduce(function (acc, val) {
            return val && acc;
          }, true);
        case 'any':
          return matches.reduce(function (acc, val) {
            return val || acc;
          }, false);
        default:
          return false;
      }
    }, _this.render = function () {
      var questions = _this.props.questions.filter(_this.shouldRender).map(_this.renderQuestion);

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'YesNo' },
          questions
        ),
        _this.allAnswered() && !_this.allOK() && React.createElement(
          'div',
          { className: 'YesNo-Error' },
          _this.props.constraint.message
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return YesNo;
}(Component);

YesNo.contextTypes = {
  form: PropTypes.object.isRequired
};

YesNo.propTypes = process.env.NODE_ENV !== "production" ? {
  constraint: PropTypes.shape({
    message: PropTypes.string.isRequired
  }),
  name: PropTypes.string,
  questions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    only_if: PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  })).isRequired
} : {};

export default YesNo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/YesNo.js
// module id = 727
// module chunks = 0